export default __webpack_public_path__ + "static/media/youtube.90fa23e4.svg";